import React from 'react'
import { Image, Nav } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Icofont from 'react-icofont';
import logofedpa from '../assets/logofedpa.svg'
import { clearStorage } from 'src/helpers/localstorage';
const TheHeader = () => {

  const refresh = () => {
    window.location.href = '/multipagos'
    clearStorage();
    return true;
  }


  return (
    <React.Fragment>
      <Navbar className='nav-fedpa'>
        <Container>
          <Navbar.Brand>
            <Image
              src={logofedpa}
              height={65}
              alt='Icono fedpa'
              className="animation-logo App-logo"
            />
          </Navbar.Brand>
          <Nav className="me-auto">
            <Nav.Link onClick={refresh} className='fw-bold'>
              Restablecer
              &nbsp;
              <Icofont icon='refresh' />
            </Nav.Link>
            {/* <Nav.Link href="#features">Portal Clientes</Nav.Link>
            <Nav.Link href="#pricing">Contactos</Nav.Link> */}
          </Nav>
        </Container>
      </Navbar>
    </React.Fragment>
  )
}

export default TheHeader;